import { Directive, ElementRef, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UriBuilder } from 'uribuilder';
import { cleanPath } from 'cleanpath';
import 'rxjs/operator/toPromise';
import 'rxjs/operator/takeUntil';
import { SafePipeModule } from 'safe-pipe';
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
var ViewProviders = {
    /**
       * Google
       */
    google: 'google',
    /**
       * Microsoft
       */
    microsoft: 'microsoft',
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DocumentViewDirective = (function () {
    /**
     * @param {?} iframe
     */
    function DocumentViewDirective(iframe) {
        this.iframe = iframe;
        this._provider = ViewProviders.google;
        this.providerChange = new EventEmitter();
        this._originSrc = ((this.iframe.nativeElement)).src;
    }
    Object.defineProperty(DocumentViewDirective.prototype, "provider", {
        /**
         * @return {?}
         */
        get: function () {
            return this._provider;
        },
        /**
         * 檢視器提供者
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._provider = value;
            this.ngOnInit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentViewDirective.prototype, "originSrc", {
        /**
         * 原始文件連結
         * @return {?}
         */
        get: function () {
            return this._originSrc;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DocumentViewDirective.prototype.ngOnInit = function () {
        ((this.iframe
            .nativeElement)).src = this.getDocumentUrl();
    };
    /**
     * 根據對應的檢視器提供者產生文件網址
     * @return {?}
     */
    DocumentViewDirective.prototype.getDocumentUrl = function () {
        if (this.provider === ViewProviders.google) {
            return ('http://docs.google.com/gview?url=' +
                encodeURI(this._originSrc) +
                '&embedded=true');
        }
        else if (this.provider === ViewProviders.microsoft) {
            return ('https://view.officeapps.live.com/op/embed.aspx?src=' +
                encodeURI(this._originSrc));
        }
        return null;
    };
    /**
     * 轉換連結與編碼
     * @param {?} url 連結
     * @return {?}
     */
    DocumentViewDirective.prototype.encodeURI = function (url) {
        if (UriBuilder.parse(url).isRelative()) {
            url = cleanPath(document.baseURI + '/' + url);
        }
        return encodeURIComponent(url);
    };
    return DocumentViewDirective;
}());
DocumentViewDirective.decorators = [
    { type: Directive, args: [{
                selector: 'iframe[ngx-document]'
            },] },
];
/** @nocollapse */
DocumentViewDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
DocumentViewDirective.propDecorators = {
    "provider": [{ type: Input },],
    "providerChange": [{ type: Output },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DocumentViewModule = (function () {
    function DocumentViewModule() {
    }
    return DocumentViewModule;
}());
DocumentViewModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, SafePipeModule],
                declarations: [DocumentViewDirective],
                exports: [DocumentViewDirective]
            },] },
];
/** @nocollapse */
DocumentViewModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { DocumentViewModule, ViewProviders, DocumentViewDirective as ɵa };
//# sourceMappingURL=ngx-document-view.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-document-view/esm5/ngx-document-view.js
// module id = ./node_modules/ngx-document-view/esm5/ngx-document-view.js
// module chunks = vendor